import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useBreadcrumbs, useUser } from '../hooks';
import { Header, Groupper, Button, Icon, Toast, Input } from 'react-frontier';
import { Contract } from '../SiteClasses';
import MDEditor, { commands } from '@uiw/react-md-editor/nohighlight';
import UserAccess from '../UserAccess';
import API from '../API';

var ContractEdit = ()=>{
	var { id } = useParams<{ id: string }>();
	var contract_id = parseInt(id);
	var { setTitle } = useBreadcrumbs();
	var { hasAccess } = useUser();
	var [contract, setContract] = useState<Contract>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		setTitle('Contrato #' + contract_id);
		get();
	}, []);

	var get = ()=>{
		API.getContract(contract_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setContract(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error al cargar el contrato.');
		});
	};

	var save = (setLoading: (l: boolean)=>void)=>{
		setLoading(true);
		API.updateContract(contract_id, contract.contract_title, contract.content).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Contrato guardado.');
		}).catch(()=>{
			Toast.error('Hubo un error al guardar el contrato.');
		}).finally(()=>{
			setLoading(false);
		});
	};

	if(loadError) return <Header text='Error' subtext={loadError} />;
	if(!contract) return <Header loading text='Cargando...' />;

	return (
		<Groupper title={`Contrato #${contract_id}`} width={700} style={{ marginTop: 20 }}
			actions={hasAccess(UserAccess.CONTRACTS.EDIT_CONTRACTS) && (
				<Button text='Guardar' color='black' onClick={save} />
			)}
		>
			<Input
				label='Título'
				value={contract.contract_title}
				onChange={v => setContract({ ...contract, contract_title: v })}
				style={{ marginBottom: 16 }}
				readonly={!hasAccess(UserAccess.CONTRACTS.EDIT_CONTRACTS)}
			/>
			<div data-color-mode='light'>
				<MDEditor
					preview='live'
					value={contract.content}
					onChange={v => setContract({ ...contract, content: v || '' })}
					height={600}
					data-color-mode='light'
					extraCommands={[
						{
							...commands.codeEdit,
							icon: <Icon name='pencil' style={{ margin: 0, fontSize: 18 }} />
						},
						{
							...commands.codeLive,
							icon: <Icon name='columns' style={{ margin: 0, fontSize: 18 }} />
						},
						{
							...commands.codePreview,
							icon: <Icon name='eye' style={{ margin: 0, fontSize: 18 }} />
						},
					]}
					commands={[
						commands.bold,
						commands.italic,
						commands.strikethrough,
						commands.divider,
						commands.hr,
						commands.title,
						commands.divider,
						commands.quote,
						commands.code,
						commands.link,
						commands.divider,
						commands.unorderedListCommand,
						commands.orderedListCommand,
					]}
				/>
			</div>
		</Groupper>
	);
};

export default ContractEdit;
